import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { PersonDocument, PersonQuery, PersonQueryVariables } from '../../../graphql-operations';
import ClientDetailView, { ClientType, NewClientIcon } from '../../client/ClientDetailView';
import PersonDetailView from '../PersonDetailView';

interface PersonDetailProps {
  personId?: string;
  listUrl: string;
}

export default function PersonSwitchDetail({ personId, listUrl }: PersonDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl}>
        <NewClientIcon />
      </ResponsiveHeaderRow>

      {!!personId && (
        <QueryWithLoader<PersonQuery, PersonQueryVariables> query={PersonDocument} variables={{ id: personId }}>
          {({ data }) => {
            const person = data.person;

            if (!person) {
              return <Redirect to="/page-not-found" />;
            }

            if (person.clientData) {
              const personAsClient: ClientType = {
                ...person,
                clientData: person.clientData
              };

              return <ClientDetailView client={personAsClient} />;
            }

            return <PersonDetailView person={person} />;
          }}
        </QueryWithLoader>
      )}

      {!personId && <NoData text="Vyberte osobu" />}
    </>
  );
}
